/* Sample nudge: one gentle offer for visitors who have looked around but not added anything to the cart.
   Desktop: a centered dialog when the pointer leaves toward the browser bar (or after a long, engaged visit).
   Also: fast flick to top on phones, return after 60s+ away, and 2 minutes idle.
   Phones: a small card at the bottom that never covers the page. Shown at most once per 14 days, never in the
   cart, checkout, account or on the sample page, and never if the cart already has items. */
(function () {
  'use strict';
  var KEY = 'tc_sample_nudge';
  var DAYS = 14;
  var path = location.pathname;
  var SAMPLE = '/pages/free-sample';
  if (/^\/(cart|checkout|account|orders|challenge)/.test(path) || path.indexOf('/pages/free-sample') === 0 || path.indexOf('/products/sample-pack') === 0) return;

  function get() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function set(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  function track(name) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, { event_category: 'sample_nudge' }); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: name }); } catch (e) {}
  }
  var st = get();
  if (st.done && Date.now() - st.done < DAYS * 864e5) return;
  try { if (sessionStorage.getItem(KEY + '_s')) return; } catch (e) {}

  var shown = false, started = Date.now(), maxScroll = 0, lastFocus = null, el = null;
  var fine = window.matchMedia && matchMedia('(hover:hover) and (pointer:fine)').matches;

  function cartEmpty() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { return c.item_count === 0; }).catch(function () { return false; });
  }
  function engaged() { return Date.now() - started > 20000; }
  window.addEventListener('scroll', function () {
    var h = document.documentElement.scrollHeight - innerHeight;
    if (h > 0) maxScroll = Math.max(maxScroll, scrollY / h);
  }, { passive: true });

  function close(why) {
    if (!el) return;
    el.setAttribute('hidden', '');
    document.documentElement.classList.remove('tc-nudge-open');
    set({ done: Date.now(), why: why });
    track('sample_nudge_' + why);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
    document.removeEventListener('keydown', onKey);
  }
  function onKey(e) {
    if (e.key === 'Escape') close('dismiss');
    if (e.key === 'Tab' && el) {
      var f = el.querySelectorAll('a[href],button');
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { z.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === z) { a.focus(); e.preventDefault(); }
    }
  }
  function build() {
    el = document.createElement('div');
    el.className = 'nudge';
    el.setAttribute('hidden', '');
    el.innerHTML =
      '<div class="nudge__scrim" data-n-close></div>' +
      '<div class="nudge__card" role="dialog" aria-labelledby="nudge-h" aria-describedby="nudge-p" tabindex="-1">' +
      '<button type="button" class="nudge__x" data-n-close aria-label="Close">&times;</button>' +
      '<p class="nudge__k mono">Not sure which gauge?</p>' +
      '<h2 id="nudge-h" class="nudge__h">Try any size for $1.99.</h2>' +
      '<p id="nudge-p" class="nudge__p">Get a sample of any gauge and length before you buy a full box. Free US shipping. Limit one per customer.</p>' +
      '<div class="nudge__a"><a class="btn btn--go" href="' + SAMPLE + '" data-n-go>Get my $1.99 sample</a>' +
      '<button type="button" class="nudge__no" data-n-close>No thanks</button></div></div>';
    document.body.appendChild(el);
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-n-go]')) { set({ done: Date.now(), why: 'click' }); track('sample_nudge_click'); return; }
      if (e.target.closest('[data-n-close]')) close('dismiss');
    });
  }
  function show() {
    if (shown) return;
    shown = true;
    cartEmpty().then(function (empty) {
      if (!empty) return;
      if (document.querySelector('.tray--open,[data-tc-sheet]:not([hidden])')) { shown = false; return; }
      try { sessionStorage.setItem(KEY + '_s', '1'); } catch (e) {}
      if (!el) build();
      lastFocus = document.activeElement;
      el.removeAttribute('hidden');
      document.documentElement.classList.add('tc-nudge-open');
      track('sample_nudge_view');
      if (fine) { var c = el.querySelector('.nudge__card'); c && c.focus({ preventScroll: true }); document.addEventListener('keydown', onKey); }
    });
  }

  if (fine) {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0 && engaged()) show();
    });
    setTimeout(function () { if (maxScroll > 0.4) show(); }, 60000);
  } else {
    var t = setInterval(function () {
      if (shown) return clearInterval(t);
      if (engaged() && maxScroll > 0.5 && Date.now() - started > 40000) { clearInterval(t); show(); }
    }, 2000);
    /* Phones: a fast flick back to the top usually means the visitor is heading for the address bar or back swipe. */
    var ly = scrollY, lt = Date.now(), peak = scrollY;
    window.addEventListener('scroll', function () {
      var y = scrollY, n = Date.now(), dt = n - lt;
      if (y > peak) peak = y;
      if (dt > 0 && dt < 400 && ly - y > 350 && (ly - y) / dt > 1.6 && peak > 900 && engaged()) show();
      if (dt >= 400) { ly = y; lt = n; } else if (y > ly) { ly = y; lt = n; }
    }, { passive: true });
  }
  /* Returning after time away (another tab or app): show once as the first thing they see. */
  var hiddenAt = 0;
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { hiddenAt = Date.now(); return; }
    if (hiddenAt && Date.now() - hiddenAt > 60000 && engaged()) show();
    hiddenAt = 0;
  });
  /* Long idle on the page. */
  var lastAct = Date.now();
  ['mousemove', 'keydown', 'touchstart', 'scroll', 'click'].forEach(function (ev) {
    window.addEventListener(ev, function () { lastAct = Date.now(); }, { passive: true });
  });
  var idle = setInterval(function () {
    if (shown) return clearInterval(idle);
    if (!document.hidden && engaged() && Date.now() - lastAct > 120000) { clearInterval(idle); show(); }
  }, 5000);
})();
